<div class="dollar">
  {{ currency | currencyfilter: 'dollar' }}
</div>
<div class="cents">.{{ currency | currencyfilter }}</div>
